import * as Yup from 'yup';

const usersValidationSchema = () => {
  let baseSchema = {
    groupName: Yup.string()
      .max(50, 'Group Name must be at most 50 characters')
      .required('Group Name is required'),
    description: Yup.string().notRequired(),
    roleId: Yup.string().required('Role is required'),
    botIds: Yup.array()
      .nullable()
      .default(undefined)
      .transform((value, originalValue) => {
        if (originalValue == null || originalValue === '') return undefined;
        return value;
      })
      .of(Yup.string().uuid('Invalid bot id'))
      .notRequired(),
  };
  return Yup.object().shape(baseSchema);
};
export default usersValidationSchema;
